import isAllUsers from "./isAllUsers";
import getAllUsers from "./getAllUsers";

export default {
    isAllUsers,
    getAllUsers
}